/*
 * MDB shim for MDBSelectInput
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 */

import MUIBox from "@mui/material/Box";

/*
 * Non-obvious mapping note:
 * MDBSelectInput is largely structural in legacy markup, so a neutral Box wrapper is sufficient.
 */
export default function MDBSelectInput({ children, ...rest }) {
    return <MUIBox {...rest}>{children}</MUIBox>;
}
